/** The product's name, which is also how the agent is named in the UI. */
export const APP_NAME = "Tinsmith";
